import {
  OrganizationAuthMethodEnum,
  type LinkedAuthMethods
} from 'src/api/main'

import type { ConnectedAccountItem } from './types'

export function buildConnectedAccountsList(
  linked: LinkedAuthMethods | undefined,
  email: string | undefined
): ConnectedAccountItem[] {
  if (!linked) {
    return []
  }

  const items: ConnectedAccountItem[] = []

  items.push({
    email: email ?? '',
    kind: 'password',
    linked: linked.has_password
  })

  const googleInfo = linked.social_providers.find(
    (provider) => provider.provider === OrganizationAuthMethodEnum.GOOGLE
  )

  items.push({
    email: googleInfo?.email ?? '',
    kind: 'social',
    linked: !!googleInfo,
    provider: OrganizationAuthMethodEnum.GOOGLE
  })

  const appleInfo = linked.social_providers.find(
    (provider) => provider.provider === OrganizationAuthMethodEnum.APPLE
  )

  items.push({
    email: appleInfo?.email ?? '',
    kind: 'social',
    linked: !!appleInfo,
    provider: OrganizationAuthMethodEnum.APPLE
  })

  return items
}
